(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function() {
  var h = document.getElementById('zd-header');
  function onScroll() { if (h) h.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  window.zdSearchOpen  = function() {
    document.getElementById('zd-search-overlay').classList.add('open');
    setTimeout(function(){ var inp = document.querySelector('#zd-search-overlay input'); if(inp) inp.focus(); }, 60);
  };
  window.zdSearchClose = function() { document.getElementById('zd-search-overlay').classList.remove('open'); };
  window.zdDrawerOpen  = function() { document.getElementById('zd-nav-drawer').classList.add('open'); document.body.style.overflow = 'hidden'; };
  window.zdDrawerClose = function() { document.getElementById('zd-nav-drawer').classList.remove('open'); document.body.style.overflow = ''; };

  window.zdAccountToggle = function() {
    var dd = document.getElementById('zd-account-dd');
    var trigger = document.getElementById('zd-account-trigger');
    if (!dd || !trigger) return;
    var open = dd.classList.toggle('open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  window.zdAccountClose = function() {
    var dd = document.getElementById('zd-account-dd');
    var trigger = document.getElementById('zd-account-trigger');
    if (dd) dd.classList.remove('open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  };
  document.addEventListener('click', function(e) {
    var wrap = document.querySelector('.zd-account-wrap');
    if (wrap && !wrap.contains(e.target)) zdAccountClose();
  });

  function zdShowCartEmptyToast() {
    var existing = document.getElementById('zd-cart-empty-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'zd-cart-empty-toast';
    toast.textContent = 'Your cart is empty';
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('zd-toast-in'); });
    setTimeout(function () {
      toast.classList.remove('zd-toast-in');
      setTimeout(function () { toast.remove(); }, 200);
    }, 1800);
  }

  window.zdCartOpen = function() {
    // Clicking an already-empty cart used to still open the full drawer just to show
    // "your cart is empty" — a lighter toast instead of the slide-out (Chuck, 2026-07-19).
    var countEl = document.getElementById('zd-cart-count');
    var count = countEl ? parseInt(countEl.dataset.count || '0', 10) : 0;
    if (!count) { zdShowCartEmptyToast(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var t = document.querySelector('[data-cart-drawer-trigger]');
    if (t) { t.click(); return; }
    window.location.href = '/cart';
  };

  document.addEventListener('cart:updated', function(e) {
    var el = document.getElementById('zd-cart-count');
    if (el && e.detail && e.detail.cart) {
      var n = e.detail.cart.item_count || 0;
      el.textContent = n; el.dataset.count = n;
    }
  });

  // Mirror Dawn's hidden #cart-icon-bubble (updated on every AJAX cart change) into our visible badge.
  // When the cart empties out, Dawn's bubble renders an empty-cart icon with no digit at all — so
  // the old regex-match skipped the update entirely and the badge stayed stuck on the last count
  // until a full page refresh (Chuck, 2026-07-19). No digit found now explicitly means zero.
  // FIX (Chuck, 2026-07-19): Dawn's real bubble markup (cart-icon-bubble.liquid) renders TWO
  // adjacent spans with no whitespace between them — <span aria-hidden="true">4</span><span
  // class="visually-hidden">4 items</span> — so grabbing the first digit run out of the STUB'S
  // FLATTENED textContent read "44 items" and matched "44" for a cart of 4. Only ever surfaced now
  // because the bubble never actually rendered real content before this session (cart-drawer/
  // cart-notification were both dead code). Read the aria-hidden count span specifically instead
  // of the whole stub's text.
  (function () {
    var stub = document.getElementById('cart-icon-bubble');
    var badge = document.getElementById('zd-cart-count');
    if (!stub || !badge || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      var countEl = stub.querySelector('[aria-hidden="true"]');
      var m = ((countEl ? countEl.textContent : stub.textContent) || '').match(/\d+/);
      var n = m ? m[0] : '0';
      badge.textContent = n; badge.dataset.count = n;
    }).observe(stub, { childList: true, subtree: true, characterData: true });
  })();

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (window.zdSearchClose) zdSearchClose();
      if (window.zdDrawerClose) zdDrawerClose();
      if (window.zdAccountClose) zdAccountClose();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-brand-categories"] && !Shopify.designMode) return;
  try {
    
(function() {
  var WORKER = 'https://zda-engine.tight-voice-31e4.workers.dev';
  var wrap = document.getElementById('zd-bc-section');
  if (!wrap) return;
  var brandName = wrap.dataset.brand || '';
  if (!brandName) return;

  function vehicle() {
    try { return JSON.parse(localStorage.getItem('zd_vehicle') || 'null'); } catch (e) { return null; }
  }

  function openTile(tile, aaiaId, brandTitle) {
    var v = vehicle();
    if (!window.ZD_openResults) return;
    if (tile.level === 'all') {
      window.ZD_openResults(null, null, v, { brand: aaiaId, label: 'All ' + brandTitle + ' Products' });
    } else if (tile.level === 'main') {
      window.ZD_openResults(tile.value, null, v, { brand: aaiaId, label: tile.label });
    } else if (tile.level === 'sub') {
      window.ZD_openResults(null, tile.value, v, { brand: aaiaId, label: tile.label });
    } else {
      window.ZD_openResults(null, null, v, { brand: aaiaId, partType: tile.value, label: tile.label });
    }
  }

  fetch(WORKER + '/zd-catalog/brand-categories?brand_name=' + encodeURIComponent(brandName))
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data || !data.is_brand || !data.tiles || !data.tiles.length) return;

      var grid = document.createElement('div');
      grid.className = 'zd-bc-grid';

      data.tiles.forEach(function(tile) {
        var card = document.createElement('div');
        card.className = 'zd-bc-card';
        card.innerHTML = '<div class="zd-bc-name">' + tile.label + '</div>' +
          '<div class="zd-bc-count">' + tile.count.toLocaleString() + '</div>';
        card.addEventListener('click', function() { openTile(tile, data.aaia_id, brandName); });
        grid.appendChild(card);
      });

      var allCard = document.createElement('div');
      allCard.className = 'zd-bc-card zd-bc-card--all';
      allCard.innerHTML = '<div class="zd-bc-name">View All</div>' +
        '<div class="zd-bc-count">' + data.total.toLocaleString() + '</div>';
      allCard.addEventListener('click', function() { openTile({ level: 'all' }, data.aaia_id, brandName); });
      grid.appendChild(allCard);

      var heading = document.createElement('div');
      heading.className = 'zd-bc-heading';
      heading.textContent = 'Shop ' + brandName + ' by Category';

      wrap.appendChild(heading);
      wrap.appendChild(grid);
      wrap.style.display = '';
    })
    .catch(function() {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-brand-marquee"] && !Shopify.designMode) return;
  try {
    
(function() {
  var WORKER = 'https://zda-engine.tight-voice-31e4.workers.dev';
  var track     = document.getElementById('zdBmTrack');
  var searchEl  = document.getElementById('zdBmSearch');
  var clearBtn  = document.getElementById('zdBmClear');
  var countEl   = document.getElementById('zdBmCount');
  var noResults = document.getElementById('zdBmNoResults');
  var brands    = [];

  function makeLogo(b) {
    var a   = document.createElement('a');
    a.className = 'zd-bm-slot';
    a.title = b.name;
    a.href = '/collections/' + b.handle;
    var pill = document.createElement('div');
    pill.className = 'zd-bm-pill';
    var img = document.createElement('img');
    img.src = b.url; img.alt = b.name; img.width = 158; img.height = 78; img.loading = 'lazy';
    img.onerror = function() { a.style.display = 'none'; };
    pill.appendChild(img);
    a.appendChild(pill);
    return a;
  }

  function buildFull() {
    track.className = 'zd-bm-track';
    track.style.animation = 'none';
    track.innerHTML = '';
    brands.forEach(function(b){ track.appendChild(makeLogo(b)); });
    brands.forEach(function(b){ track.appendChild(makeLogo(b)); });
    requestAnimationFrame(function(){ track.style.animation = ''; });
    if (noResults) noResults.style.display = 'none';
    if (countEl) countEl.textContent = 'Inventory added & adjusted daily';
  }

  function buildFiltered(q) {
    var m = brands.filter(function(b){ return b.name.toLowerCase().startsWith(q.toLowerCase()); });
    track.className = 'zd-bm-track--static';
    track.innerHTML = '';
    if (!m.length) { if(noResults) noResults.style.display='block'; if(countEl) countEl.textContent='0 results'; return; }
    if (noResults) noResults.style.display = 'none';
    m.forEach(function(b){ track.appendChild(makeLogo(b)); });
    if (countEl) countEl.textContent = m.length + ' result' + (m.length!==1?'s':'');
  }

  function init(data) {
    brands = (data && data.length) ? data.filter(function(b){ return b.active !== false && b.handle; }) : [];
    buildFull();
    if (searchEl) {
      searchEl.addEventListener('input', function() {
        var q = this.value.trim();
        if (clearBtn) clearBtn.style.display = q ? 'block' : 'none';
        q ? buildFiltered(q) : buildFull();
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if(searchEl) searchEl.value='';
        clearBtn.style.display='none';
        buildFull();
        if(searchEl) searchEl.focus();
      });
    }
  }

  fetch(WORKER + '/theme/config?key=brand-marquee')
    .then(function(r){return r.json();})
    .then(function(d){ init(d.data); })
    .catch(function(){ init(null); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-categories"] && !Shopify.designMode) return;
  try {
    
(function() {
  var WORKER   = 'https://zda-engine.tight-voice-31e4.workers.dev';
  var INTERVAL = 15000;
  var FADE     = 800;

  function buildSlideshow(area, urls) {
    area.style.position = 'relative';
    var imgs = urls.map(function(url, i) {
      var img = document.createElement('img');
      img.src = url; img.alt = ''; img.loading = i === 0 ? 'eager' : 'lazy';
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;transition:opacity ' + FADE + 'ms ease;opacity:' + (i === 0 ? '1' : '0');
      area.appendChild(img);
      return img;
    });
    if (urls.length < 2) return;
    var cur = 0;
    setInterval(function() { imgs[cur].style.opacity='0'; cur=(cur+1)%imgs.length; imgs[cur].style.opacity='1'; }, INTERVAL);
  }

  function applySlides(slides) {
    document.querySelectorAll('.zd-cat-card').forEach(function(card) {
      var href   = card.getAttribute('href') || '';
      var handle = href.replace('/collections/','').split('?')[0];
      var raw    = slides[handle];
      // Normalize: handle both legacy string[] and new {url,active}[] formats
      var urls = (raw || [])
        .filter(function(item) { return typeof item === 'string' ? true : item.active !== false; })
        .map(function(item)    { return typeof item === 'string' ? item : item.url; });
      var area = card.querySelector('.zd-cat-image-area');
      if (!area) return;
      if (urls && urls.length) { buildSlideshow(area, urls); return; }
      // No hand-picked slides for this Main yet (new/renamed Main): fall back to photos of its own live products.
      fetch('/collections/' + handle + '/products.json?limit=4')
        .then(function(r){ return r.json(); })
        .then(function(d){
          var fallback = ((d && d.products) || []).map(function(p){ return p.images && p.images[0] && p.images[0].src; }).filter(Boolean).slice(0, 3);
          if (fallback.length && !area.querySelector('img')) buildSlideshow(area, fallback);
        })
        .catch(function(){});
    });
  }

  fetch(WORKER + '/theme/config?key=category-slides')
    .then(function(r){return r.json();})
    .then(function(d){ if(d.data) applySlides(d.data); })
    .catch(function(){});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var WORKER = 'https://zda-engine.tight-voice-31e4.workers.dev';

  function injectHeroImages(slides) {
    if (!slides || !slides.length) return;
    var active = slides.filter(function(s) { return s.active !== false; });
    if (!active.length) return;
    var container = document.querySelector('.zd-hero__slides');
    if (!container) return;
    // Mobile gets its own fit/focal-point/zoom when set (see the Theme Content
    // Manager's Hero Images tab) — falls back to the desktop value when a slide
    // has no mobile override, so existing slides behave unchanged. The hero box
    // itself flips shape between breakpoints (wide strip desktop, full-height
    // mobile), so the same crop rarely looks right on both (Chuck, 2026-07-15).
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    // The section now server-renders these same slides (desktop crop) directly for LCP —
    // this fetch just keeps things live-editable from OPS without a theme push. If nothing
    // actually changed since the page was rendered, skip the rebuild entirely so we don't
    // flash/replace an image that already painted correctly (Chuck, 2026-07-19).
    var currentSrcs = Array.prototype.map.call(container.querySelectorAll('.zd-hero__slide-img'), function (img) {
      return img.getAttribute('src');
    });
    var freshSrcs = active.map(function (s) { return s.image_url; });
    var srcsMatch = currentSrcs.length === freshSrcs.length && currentSrcs.every(function (src, i) { return src === freshSrcs[i]; });
    var hasMobileOverride = isMobile && active.some(function (s) { return s.mobile_fit || s.mobile_focal_point || s.mobile_zoom; });
    if (srcsMatch && !hasMobileOverride) {
      if (window.zdHeroInit) window.zdHeroInit();
      return;
    }

    container.classList.add('zd-loading');
    container.innerHTML = '';
    active.forEach(function(slide, i) {
      var div = document.createElement('div');
      div.className = 'zd-hero__slide' + (i === 0 ? ' active' : '');
      var focal = (isMobile && slide.mobile_focal_point) ? slide.mobile_focal_point : slide.focal_point;
      var zoom  = (isMobile && slide.mobile_zoom)        ? slide.mobile_zoom        : slide.zoom;
      var fit   = (isMobile && slide.mobile_fit)          ? slide.mobile_fit         : slide.fit;
      // "contain-blur" = the full image uncropped (never clips text/logos) with a
      // softened, zoomed copy of the same image filling the box behind it instead
      // of empty space. Not a real CSS object-fit value — resolve to plain
      // "contain" for the sharp image and add the blurred backdrop layer.
      if (fit === 'contain-blur') {
        var backdrop = document.createElement('img');
        backdrop.src = slide.image_url; backdrop.alt = ''; backdrop.setAttribute('aria-hidden', 'true');
        backdrop.className = 'zd-hero__slide-backdrop'; backdrop.loading = i === 0 ? 'eager' : 'lazy'; backdrop.decoding = 'async';
        backdrop.width = 1920; backdrop.height = 1080;
        div.appendChild(backdrop);
      }
      var img = document.createElement('img');
      img.src = slide.image_url; img.alt = slide.alt || ''; img.className = 'zd-hero__slide-img'; img.loading = i === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.width = 1920; img.height = 1080;
      if (i === 0) img.fetchPriority = 'high';
      if (focal) { img.style.objectPosition = focal; img.style.transformOrigin = focal; }
      if (zoom && zoom !== 100) img.style.transform = 'scale(' + (zoom / 100) + ')';
      var effectiveFit = (fit === 'contain-blur') ? 'contain' : fit;
      if (effectiveFit) { img.style.objectFit = effectiveFit; if (effectiveFit === 'contain') div.style.background = '#050a12'; }
      var overlay = document.createElement('div');
      overlay.className = 'zd-hero__slide-overlay';
      div.appendChild(img); div.appendChild(overlay);
      container.appendChild(div);
    });

    // Rebuild the dots to match the injected slides, then restart the slideshow
    var section = container.closest('.zd-hero');
    if (section) {
      var dotsWrap = section.querySelector('.zd-hero__dots');
      if (active.length > 1) {
        if (!dotsWrap) { dotsWrap = document.createElement('div'); dotsWrap.className = 'zd-hero__dots'; section.appendChild(dotsWrap); }
        dotsWrap.innerHTML = '';
        active.forEach(function(slide, i) {
          var b = document.createElement('button');
          b.className = 'zd-hero__dot' + (i === 0 ? ' active' : '');
          b.setAttribute('data-slide', i);
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dotsWrap.appendChild(b);
        });
      } else if (dotsWrap) {
        dotsWrap.innerHTML = '';
      }
    }

    // Reveal only once the first image is fully decoded — fade it in whole
    // instead of letting a large baseline JPEG paint in top-to-bottom.
    var firstImg = container.querySelector('.zd-hero__slide-img');
    var revealed = false;
    var reveal = function() { if (revealed) return; revealed = true; container.classList.remove('zd-loading'); };
    if (firstImg && firstImg.decode) {
      firstImg.decode().then(reveal).catch(reveal);
    } else if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', reveal);
      firstImg.addEventListener('error', reveal);
    } else {
      requestAnimationFrame(reveal);
    }
    setTimeout(reveal, 2000); // safety net so the hero never stays hidden
    if (window.zdHeroInit) window.zdHeroInit(section);
  }

  function hmHexA(hex, a) {
    hex = (hex || '').replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var r = parseInt(hex.slice(0,2),16), g = parseInt(hex.slice(2,4),16), b = parseInt(hex.slice(4,6),16);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  }
  function hmStripeGradient(colors) {
    var n = colors.length, stops = [];
    for (var i = 0; i < n; i++) {
      stops.push(colors[i] + ' ' + (i / n * 100) + '%');
      stops.push(colors[i] + ' ' + ((i + 1) / n * 100) + '%');
    }
    return 'linear-gradient(90deg,' + stops.join(',') + ')';
  }
  function hmStyleItem(item, cfg) {
    if (cfg.striped && cfg.colors && cfg.colors.length >= 2) {
      item.style.background = hmStripeGradient(cfg.colors);
      item.style.webkitBackgroundClip = 'text';
      item.style.backgroundClip = 'text';
      item.style.webkitTextFillColor = 'transparent';
      item.style.color = 'transparent';
      item.style.textShadow = 'none';
      item.style.filter = 'drop-shadow(0 2px 6px rgba(0,0,0,.7))';
    } else if (cfg.color) {
      item.style.color = cfg.color;
      item.style.webkitTextFillColor = cfg.color;
      item.style.textShadow = '0 0 12px ' + hmHexA(cfg.color, 0.35) + ', 0 2px 14px rgba(0,0,0,.75)';
    }
  }

  function applyMarquee(cfg) {
    var wrap = document.querySelector('.zd-hero__marquee-wrap');
    if (!wrap || !cfg) return; // no config saved → keep the theme-editor default
    var track = wrap.querySelector('.zd-hero__marquee-track');
    if (cfg.enabled === false || !cfg.text) { wrap.style.display = 'none'; return; }
    // Split on commas → each phrase becomes its own segment with a separator after it
    var phrases = cfg.text.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    if (!phrases.length) { wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    if (!track) return;
    track.innerHTML = '';
    var sep = cfg.sep || '◆';
    var sepColor = (cfg.striped && cfg.colors && cfg.colors.length) ? cfg.colors[0] : cfg.color;
    // Repeat the full phrase-set an even number of times so the -50% loop stays seamless
    var sets = Math.max(2, Math.ceil(20 / phrases.length));
    if (sets % 2 !== 0) sets++;
    var frag = document.createDocumentFragment();
    for (var n = 0; n < sets; n++) {
      phrases.forEach(function(p) {
        var item = document.createElement('span');
        item.className = 'zd-hero__marquee-item';
        item.textContent = p;
        hmStyleItem(item, cfg);
        var s = document.createElement('span');
        s.className = 'zd-hero__marquee-sep';
        s.textContent = sep;
        if (sepColor) s.style.color = sepColor;
        frag.appendChild(item); frag.appendChild(s);
      });
    }
    track.appendChild(frag);
    track.style.animationDuration = (cfg.speed || 60) + 's';
  }

  function run() {
    // Always fetch fresh — no sessionStorage so toggle ON/OFF takes effect immediately
    fetch(WORKER + '/theme/config?key=hero', { cache: 'no-store' })
      .then(function(r){return r.json();})
      .then(function(d){
        if (d.data && d.data.slides) injectHeroImages(d.data.slides);
      }).catch(function(){});

    fetch(WORKER + '/theme/config?key=hero-marquee', { cache: 'no-store' })
      .then(function(r){return r.json();})
      .then(function(d){ if (d.data) applyMarquee(d.data); })
      .catch(function(){});
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-ymm"] && !Shopify.designMode) return;
  try {
    
(function() {
  var yearSel     = document.getElementById('zd-ymm-year');
  var makeSel     = document.getElementById('zd-ymm-make');
  var modelSel    = document.getElementById('zd-ymm-model');
  var subSel      = document.getElementById('zd-ymm-submodel');
  var submitBtn   = document.getElementById('zd-ymm-submit');
  var workerBase  = 'https://zda-vin.tight-voice-31e4.workers.dev';

  if (!yearSel) return;

  function resetSelect(sel, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    sel.disabled = true;
  }

  function populate(sel, items, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    items.forEach(function(val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      sel.appendChild(opt);
    });
    sel.disabled = false;
  }

  yearSel.addEventListener('change', function() {
    resetSelect(makeSel, 'Select Make');
    resetSelect(modelSel, 'Select Model');
    resetSelect(subSel, 'Select Submodel');
    if (!this.value) return;

    fetch(workerBase + '/zd-ymm/makes?year=' + this.value)
      .then(function(r) { return r.json(); })
      .then(function(data) { populate(makeSel, data, 'Select Make'); })
      .catch(function() {});
  });

  makeSel.addEventListener('change', function() {
    resetSelect(modelSel, 'Select Model');
    resetSelect(subSel, 'Select Submodel');
    if (!this.value) return;

    fetch(workerBase + '/zd-ymm/models?year=' + yearSel.value + '&make=' + encodeURIComponent(this.value))
      .then(function(r) { return r.json(); })
      .then(function(data) { populate(modelSel, data, 'Select Model'); })
      .catch(function() {});
  });

  modelSel.addEventListener('change', function() {
    resetSelect(subSel, 'Select Submodel');
    subSel.disabled = false;
    if (!this.value) return;
  });

  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    var y = yearSel.value;
    var mk = makeSel.value;
    var mo = modelSel.value;
    if (!y || !mk || !mo) return;
    var tag = 'fit:' + y + ':' + mk.toLowerCase().replace(/\s+/g, '-') + ':' + mo.toLowerCase().replace(/\s+/g, '-');
    window.location.href = '/collections/all?sort_by=best-selling&filter.p.tag=' + encodeURIComponent(tag);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
